var throttle = require('./throttle');
var debounce = require('./debounce');

module.exports = {
	throttle: throttle,
	debounce: debounce
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/throttle-debounce/index.js
// module id = 411
// module chunks = 2